import React from "react"
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom"
import ReactDOM from 'react-dom'
import Home from './components/Home/Home'
import Header from './components/Header'
import Rodape from './components/Rodape'
import Sobre from './components/Sobre'
import Servicos from './components/Servicos'
import Contato from './components/Contato'
import SGQ from './components/SGQ'
import Solucoes from './components/Solucoes'
import ScrollToTop from './ScrollToTop'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div>
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/servicos" component={Servicos} />
          <Route path="/sgq" component={SGQ} />
          <Route path="/solucoes" component={Solucoes} />
          <Route path="/sobre" component={Sobre} />
          <Route path="/contato" component={Contato} />
          <Redirect from="*" to="/" />
        </Switch>
        <Rodape />
      </div>
    </Router>
  )
}

ReactDOM.render(<App/>, document.getElementById('root'));

export default App
